<template>
    <page :showBackButton="true">
        <!-- <template v-slot:header>
      <ion-title>{{ contract.Name }}</ion-title>
    </template> -->
        <contract-card :contractId="contractId"></contract-card>
        <coach-card
            :contractId="contractId"
            :motive="motive"
            :showGender="true"
        ></coach-card>
        <expansion-card v-if="info !== ''">
            <template v-slot:header>
                <b>Wichtiger Hinweis</b>
            </template>
            <div v-html="info"></div>
        </expansion-card>
        <ion-grid>
            <ion-row>
                <ion-col size="4">
                    <pagelink
                        :path="{
                            name: 'vertragsdetails',
                            params: { motive: motive, contractId: contractId },
                        }"
                        icon="flame"
                        title="Vertragsdetails"
                    />
                </ion-col>
                <!-- <ion-col
                    size="4"
                    v-if="
                        Object.keys(contractDetails).length > 0 &&
                        !contractDetails['BankAccountData']
                    "
                >
                    <pagelink
                        :path="{
                            name: 'sepa-lastschrift',
                            params: { motive: motive, contractId: contractId },
                        }"
                        icon="flame"
                        title="SEPA Lastschrift-Mandat"
                    />
                </ion-col> -->
                <ion-col size="4">
                    <pagelink
                        :path="{
                            name: 'umsaetze',
                            params: { motive: motive, contractId: contractId },
                        }"
                        icon="flame"
                        title="Umsätze"
                    />
                </ion-col>
                <template
                    v-if="'FlexibleLife' in features || 'Vollwert' in features"
                >
                    <ion-col size="4">
                        <pagelink
                            :path="{
                                name: 'uebersicht',
                                params: {
                                    motive: motive,
                                    contractId: contractId,
                                },
                            }"
                            icon="flame"
                            title="Übersicht"
                        />
                    </ion-col>
                    <template
                        v-if="
                            isFlexiblelifeChangePossible ||
                            isVollwertChangePossible
                        "
                    >
                        <!-- Commented out, because Services are not available (IDD) -->
                        <!-- <ion-col size="4">
              <pagelink
                :path="{ name: 'anpassen', params: { motive: motive, contractId: contractId }}"
                icon="flame"
                title="Anpassen"
              />
            </ion-col>
            <ion-col size="4">
              <pagelink
                :path="{ name: 'einzahlung', params: { motive: motive, contractId: contractId } }"
                icon="flame"
                title="Einzahlung"
              />
            </ion-col> -->
                        <ion-col size="4">
                            <pagelink
                                :path="{
                                    name: 'auszahlung',
                                    params: {
                                        motive: motive,
                                        contractId: contractId,
                                    },
                                }"
                                icon="flame"
                                title="Auszahlung"
                            />
                        </ion-col>
                    </template>
                    <!-- <ion-col size="4">
                        <pagelink
                            :path="{
                                name: 'fonds',
                                params: {
                                    motive: motive,
                                    contractId: contractId,
                                },
                            }"
                            icon="flame"
                            title="Fonds"
                        />
                    </ion-col> -->
                </template>
                <ion-col size="4" v-if="'Spontan' in features">
                    <pagelink
                        :path="{
                            name: 'spontanrueckzahlung',
                            params: { motive: motive, contractId: contractId },
                        }"
                        icon="flame"
                        title="Spontanrückzahlung"
                    />
                </ion-col>
                <ion-col size="4" v-if="'Schadensmeldung' in features">
                    <pagelink
                        :path="{
                            name: schadensmeldungPageName,
                            params: { motive: motive, contractId: contractId },
                        }"
                        icon="flame"
                        title="Schadensmeldung"
                    />
                </ion-col>
                <ion-col size="4" v-if="'Unwetter' in features">
                    <pagelink
                        :path="{
                            name: 'unwetterwarnung',
                            params: { motive: motive, contractId: contractId },
                        }"
                        icon="flame"
                        title="Unwetterwarnung"
                    />
                </ion-col>
                <ion-col
                    size="4"
                    v-if="
                        motive === 'wohnen' && contract.Sparte !== 'Rechtschutz'
                    "
                >
                    <pagelink
                        path="/services/dokbox?ansicht=gallery&ordner=Bautagebuch"
                        icon="flame"
                        title="Bautagebuch"
                    />
                </ion-col>
                <!-- <ion-col
                    size="4"
                    v-if="
                        'EbikeTracker' in features &&
                        $store.getters[
                            'contractsDetails/hasMobilitaetsSchutzPlus'
                        ]
                    "
                >
                    <pagelink
                        :path="{
                            name: 'biketrax',
                            params: { motive: motive, contractId: contractId },
                        }"
                        icon="flame"
                        title="eBike Tracker"
                    />
                </ion-col> -->
                <!-- <ion-col size="4" v-if="'KFZPromo' in features && !hideVoucher">
                    <pagelink
                        :path="{
                            name: 'gutschein',
                            params: { motive: motive, contractId: contractId },
                        }"
                        icon="flame"
                        title="Auszahlung Gutschein"
                    />
                </ion-col> -->
                <ion-col size="4" v-if="isKfzMotionCloudPossible">
                    <pagelink
                        :path="{
                            name: 'kfz-begutachtung',
                            params: { motive: motive, contractId: contractId },
                        }"
                        icon="flame"
                        title="Online KFZ-Begutachtung"
                    />
                </ion-col>
                <ion-col
                    size="4"
                    v-if="'InternationalInsuranceCard' in features"
                >
                    <pagelink
                        :path="false"
                        icon="flame"
                        title="Grüne Karte herunterladen"
                        @click.native="getGreenCard"
                    />
                </ion-col>
            </ion-row>
        </ion-grid>
    </page>
</template>

<script>
import Page from "@/components/Page";
import Pagelink from "@/components/Pagelink";
import ContractCard from "@/components/ContractCard";
import CoachCard from "@/components/CoachCard";
import ExpansionCard from "@/components/ExpansionCard";
import { Plugins } from "@capacitor/core";
import { file } from "@/mixins/file";
import { BASEURL } from "@/utils/globals";

const { Storage } = Plugins;

export default {
    mixins: [file],
    components: {
        Page,
        Pagelink,
        ContractCard,
        CoachCard,
        ExpansionCard,
    },
    props: ["contractId", "motive"],
    data() {
        return {
            hostname: window.location.hostname,
            hideVoucher: false,
            baseurl: BASEURL,
            greenCardPath:
                "/servlets/klickmal/api/?Mode=MeinServicebereich&Function=GetInternationalInsuranceCard&vertragsnummer=" +
                this.contractId,
        };
    },
    mounted() {
        this.checkFeatures();
        Storage.get({ key: "hideVoucher" }).then(({ value: val }) => {
            if (val === "true") {
                this.hideVoucher = true;
            }
        });
    },
    watch: {
        features() {
            this.checkFeatures();
        },
    },
    computed: {
        contractDetails() {
            let result = {};
            if (this.contractId in this.$store.state.contractsDetails.all) {
                result = this.$store.state.contractsDetails.all[
                    this.contractId
                ];
            }
            return result;
        },
        isKfzMotionCloudPossible() {
            let result = false;
            const contractsDetails = this.$store.state.contractsDetails.all;
            if (
                contractsDetails[this.contractId] &&
                contractsDetails[this.contractId].KfzMotionCloudPossible
            ) {
                result = true;
            }
            return result;
        },
        schadensmeldungPageName() {
            let name = "motive-schadensmeldung";
            if ("SchadensmeldungKfz" in this.features) {
                name = "motive-schadensmeldung-kfz";
            } else if ("SchadensmeldungHaushalt" in this.features) {
                name = "motive-schadensmeldung-haushalt";
            } else if ("SchadensmeldungSach" in this.features) {
                name = "motive-schadensmeldung-sach";
            } else if (
                "SchadensmeldungRecht" in this.features ||
                "SchadensmeldungRechtKfz" in this.features ||
                "SchadensmeldungRechtSach" in this.features
            ) {
                name = "motive-schadensmeldung-recht";
            }
            return name;
        },
        contract() {
            var result = "";
            if (this.contractId in this.$store.state.contracts) {
                result = this.$store.state.contracts[this.contractId];
            }
            return result;
        },
        features() {
            let result = {};
            if (
                this.contractId in this.$store.state.contracts &&
                "Features" in this.$store.state.contracts[this.contractId]
            ) {
                result = this.$store.state.contracts[this.contractId].Features;
            }
            return result;
        },
        info() {
            let result = "";
            let vorsorge = {};
            if ("FlexibleLife" in this.features) {
                vorsorge = this.$store.state.flexiblelife.all;
            } else if ("Vollwert" in this.features) {
                vorsorge = this.$store.state.vollwert.all;
            }
            if (
                Object.keys(vorsorge).length > 0 &&
                this.contractId in vorsorge &&
                "infonachricht" in vorsorge[this.contractId]
            ) {
                result = vorsorge[this.contractId].infonachricht;
            }
            return result;
        },
        isFlexiblelifeChangePossible() {
            let result = false;
            if (
                this.contractId in this.$store.state.flexiblelife.all &&
                "flexiblelifechangemoeglich" in
                    this.$store.state.flexiblelife.all[this.contractId]
            ) {
                result = this.$store.state.flexiblelife.all[this.contractId]
                    .flexiblelifechangemoeglich;
            }
            return result;
        },
        isVollwertChangePossible() {
            let result = false;
            if (
                this.contractId in this.$store.state.vollwert.all &&
                "vollwertchangemoeglich" in
                    this.$store.state.vollwert.all[this.contractId]
            ) {
                result = this.$store.state.vollwert.all[this.contractId]
                    .vollwertchangemoeglich;
            }
            return result;
        },
    },
    methods: {
        getGreenCard() {
            this.downloadFile(this.baseurl + this.greenCardPath);
            // this.$ionic.actionSheetController
            //     .create({
            //         header: "Grüne Karte",
            //         buttons: [
            //             {
            //                 text: "Herunterladen",
            //                 icon: "download",
            //                 handler: () => {
            //                     this.downloadFile(
            //                         this.baseurl + this.greenCardPath
            //                     );
            //                 },
            //             },
            //             {
            //                 text: "Teilen",
            //                 icon: "share",
            //                 handler: () => {
            //                     Share.share({
            //                         url: "Test",
            //                     }).catch((error) => {
            //                         this.$ionic.toastController
            //                             .create({
            //                                 color: "dark",
            //                                 duration: 2000,
            //                                 message: error,
            //                                 showCloseButton: true,
            //                                 closeButtonText: "Schließen",
            //                             })
            //                             .then((toast) => {
            //                                 toast.present();
            //                             });
            //                     });
            //                 },
            //             },
            //             {
            //                 text: "Schließen",
            //                 icon: "close",
            //                 role: "cancel",
            //             },
            //         ],
            //     })
            //     .then((a) => a.present());
        },
        checkFeatures() {
            if ("FlexibleLife20" in this.features) {
                this.$store.cache.dispatch(
                    "flexiblelife/getFlexibleLife20",
                    this.contractId
                );
            } else if ("FlexibleLife" in this.features) {
                this.$store.cache.dispatch(
                    "flexiblelife/getFlexibleLife",
                    this.contractId
                );
            } else if ("Vollwert" in this.features) {
                this.$store.cache.dispatch(
                    "vollwert/getVollwert",
                    this.contractId
                );
            } else if (
                "EbikeTracker" in this.features ||
                this.contract.Sparte === "KFZ" ||
                this.contract.Sparte === "Finanzierung"
            ) {
                this.$store.cache.dispatch(
                    "contractsDetails/getContractDetails",
                    this.contractId
                );
            }
        },
    },
};
</script>

<style></style>
